import AppName from "../AppName";
import Cart from "../Cart/Cart";

const MobileNavbar = () => {
  return (
    <>
      <nav
        className={`md:hidden flex justify-between items-center px-4 py-3 text-white bg-purple-800 shadow-md w-full`}
      >
        <AppName CSSStyles={"text-2xl"} />
        <div className="flex gap-4">
          <Cart />
        </div>
      </nav>
    </>
  );
};

export default MobileNavbar;
